import * as React from 'react';

import {ToastReact} from 'common/components/toast';
import {i18next, LocaleSafeString, StrictTranslatable} from 'common/i18n';
import {LocalizationStore} from 'common/i18n/store';
import {formatTextReact} from 'common/util/format-text-react';
import {withStyles} from 'common/util/react';

import type {Toast} from './';
import css from './index.module.styl?inline';
import styles from './index.module.styl';

const i18nStore = new LocalizationStore(i18next);

interface ToastAreaContentProps {
  toasts: readonly Toast[];
  onAction: (toast: Toast) => void;
  onClose: (toast: Toast) => void;
  onUndo: (toast: Toast) => void;
}

function ToastAreaContent({toasts, onAction, onClose, onUndo}: ToastAreaContentProps) {
  return (
    <div className={styles.mpToastArea}>
      {toasts.map((toast) => {
        const resolvedMessage: StrictTranslatable | LocaleSafeString | React.ReactNode =
          typeof toast.message === `function` ? i18nStore.print(toast.message) : toast.message;
        const messageNode =
          typeof resolvedMessage === `string` ? formatTextReact(resolvedMessage) : (resolvedMessage as React.ReactNode);
        return (
          <ToastReact
            key={toast.id}
            cta={toast.cta || ``}
            ctaHref={toast.ctaHref || ``}
            ctaTarget={toast.ctaTarget || ``}
            elref={toast.elref || `toast${toast.id}`}
            hide={toast.hide}
            hideCancelButton={toast.hideCancelButton}
            undoable={toast.undoable}
            undoLabel={toast.undoLabel || `Undo`}
            timeout={toast.isStatic ? null : toast.timeout}
            type={toast.type}
            message={messageNode}
            onAction={(ev) => {
              // ToastReact.fireWithDefaultClose auto-invokes onClose after
              // onAction/onUndo unless the handler calls preventDefault.
              // Suppress that here because index.tsx's outer handlers already
              // close the toast explicitly (otherwise closeToastCallback would
              // fire on every CTA/Undo click).
              ev.preventDefault();
              onAction(toast);
            }}
            onClose={() => onClose(toast)}
            onUndo={(ev) => {
              ev.preventDefault();
              onUndo(toast);
            }}
          />
        );
      })}
    </div>
  );
}

export const ToastAreaReact = withStyles(ToastAreaContent, css);
